/**
 * @desc 获取用户对应所有管理域
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.QueryBaseInfoResponse>>> {
  return defHttp.get({
    url: '/wap/base/listUserBaseInfos',
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.QueryBaseInfoResponse>>> {
  return defHttp.get({
    url: '/mock/wap/base/listUserBaseInfos',
  });
}
